import styled from '@emotion/styled';

const S = {};

S.Price = styled.h4`
  text-transform: ${({ isFree }) => (isFree ? 'capitalize;' : 'initial')};
`;

export default S;
